import { render, staticRenderFns } from "./WeasisIcon.vue?vue&type=template&id=190e41b0&"
import script from "./WeasisIcon.vue?vue&type=script&lang=js&"
export * from "./WeasisIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports